import { createAsyncThunk } from "@reduxjs/toolkit";

import { addAgencyFeeListData, deleteAgencyFeeListData, fetchAgencyFeeList, updateAgencyFeeListData } from "../../apis/agencyFee";

export const fetchAgencyFeeDatas = createAsyncThunk(
  "agencyFee/fetchAgencyFee",
  async (_, { rejectWithValue }) => {
    try {
      const fees = await fetchAgencyFeeList();
      return fees;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  } , {
      condition: (_, { getState }) => {
        const state = getState() as any; // Replace 'any' with your RootState type
        return !state.agencyFee.isDataFetched; // Adjust path based on your state structure
      }
    }
);


export const updateAgencyFee = createAsyncThunk(
  "agencyFee/updateAgencyFee",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        agencyFeeId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateAgencyFeeListData(id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAgencyFee = createAsyncThunk(
  "agencyFee/deleteAgencyFee",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteAgencyFeeListData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewAgencyFeeData = createAsyncThunk(
  "agencyFee/deleteAgencyFeeData",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addAgencyFeeListData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
